import { useGetAgendasQuery } from '../services/agendas.services';
import { AgendaFilter } from '../models';
import { PaginatedRequest } from '@/types';

interface UseAgendasProps {
  filters: AgendaFilter;
  paginated: PaginatedRequest;
}

const useAgendas = ({ filters, paginated }: UseAgendasProps) => {
  const {
    data: agendas,
    isLoading: isAgendasLoading,
    error,
  } = useGetAgendasQuery({ filters, paginated });

  return {
    agendas: agendas?.items || [],
    totalItems: agendas?.count || [].length, 
    totalPages: agendas?.count
      ? Math.ceil(agendas.count / paginated.pageSize)
      : 0,
    isAgendasLoading,
    error,
  };
};

export default useAgendas;